import axios from "axios"
const API_URL = process.env.REACT_APP_BASE_API_URL
const CREATE_LEGAL_COMPILANCE = `${API_URL}/stakeholders/legal-compliances`

export const createLegalCompilance = (payload: any, companyId: number) => {
    return axios.post(`${CREATE_LEGAL_COMPILANCE}`, payload, {
      headers: {
        'x-company-id': companyId.toString(),
      },
      validateStatus(status) {
        return true
      },
    })
  }

  export const getLegalCompilance = (
    companyId: number,
    page: number,
    pageSize: number,
    type?: string,
    sortBy?: string
  ) => {
    return axios.get(
      `${CREATE_LEGAL_COMPILANCE}?page=${page}&pageSize=${pageSize}${type ? `&type=${type}` : ''}${
        sortBy ? `&sortBy=${sortBy}` : ''
      }`,
      {
        headers: {
          'x-company-id': companyId,
        },
        validateStatus(status) {
          return true
        },
      }
    )
  }

  export const importLegalCompilance = (data: any, companyId: number) => {
    return axios.post(`${CREATE_LEGAL_COMPILANCE}/csv/import`, {legalCompliances: data}, {
      headers: {
        'x-company-id': companyId.toString(),
      },
      validateStatus(status) {
        return true
      },
    })
  }

  export const exportLegalCompilance = (companyId: number) => {
    return axios.get(`${CREATE_LEGAL_COMPILANCE}/csv/export`, {
      headers: {
        'x-company-id': companyId.toString(),
      },
      validateStatus(status) {
        return true
      },
    })
  }

  export const getLegalCompilanceStatistics = (companyId: number) => {
    return axios.get(`${CREATE_LEGAL_COMPILANCE}/statistics`, {
      headers: {
        'x-company-id': companyId.toString(),
      },
      validateStatus(status) {
        return true
      },
    })
  }

  export const getLegalCompilanceDetails = (legalCompilanceId: string, companyId: number) => {
    return axios.get(`${CREATE_LEGAL_COMPILANCE}/${legalCompilanceId}`, {
      headers: {
        'x-company-id': companyId,
      },
      validateStatus(status) {
        return true
      },
    })
  }

  export const updateLegalCompilance = (
    payload: any,
    companyId: number,
    legalCompilanceId: string
  ) => {
    return axios.post(`${CREATE_LEGAL_COMPILANCE}/${legalCompilanceId}`, payload, {
      headers: {
        'x-company-id': companyId.toString(),
      },
      validateStatus(status) {
        return true
      },
    })
  }

  export const deleteLegalMember = (memberId: string, companyId: number) => {
    return axios.delete(`${CREATE_LEGAL_COMPILANCE}/${memberId}`, {
      headers: {
        'x-company-id': companyId.toString(),
      },
      validateStatus(status) {
        return true
      },
    })
  }